import isNil from 'lodash/isNil';

import type { RuleObject, StoreValue } from 'rc-field-form/lib/interface';
import { PhoneNumberUtil } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();

export const getNameValidator =
  (required?: boolean, requiredMessage?: string) => (rule: RuleObject, value: StoreValue) => {
    const preparedValue = String(value ?? '').trim();

    if (preparedValue === '' && required) {
      return Promise.reject(requiredMessage ?? 'The field should have letters');
    }

    if ((isNil(value) || value === '') && !required) {
      return Promise.resolve();
    }

    return preparedValue.match(/[a-zA-Z-]+$/g)?.[0] === preparedValue
      ? Promise.resolve()
      : Promise.reject('Only letters and hyphen symbol are allowed');
  };

export const phoneValidator = (rule: RuleObject, value: StoreValue) => {
  try {
    if (typeof value === 'string' && value.length > 0) {
      const parsedNumber = phoneUtil.parse(value, 'US');
      const possible = phoneUtil.isPossibleNumber(parsedNumber);
      const valid = phoneUtil.isValidNumber(parsedNumber);
      if (!possible || !valid) return Promise.reject('Phone number is not valid');
    }

    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
};

